export const REQUERIR_MUDANCA_SENHA = "REQUERIR_MUDANCA_SENHA";
export const REDEFINIR_SENHA = "REDEFINIR_SENHA";
